import { useEffect } from 'react';

/**
 * Generic component for arrow key navigation through lists
 * Usage: Pass list, currentIndex, getItemId function, and onNavigate callback
 */
const ArrowKeyNavigationHandler = ({
  list,
  currentIndex,
  getItemId,
  onNavigate
}) => {
  useEffect(() => {
    const handleArrowKeyNavigation = event => {
      if (!list || list.length === 0) {
        return;
      }

      const activeElement = document.activeElement;
      if (
        activeElement &&
        (activeElement.tagName === 'INPUT' ||
          activeElement.tagName === 'TEXTAREA' ||
          activeElement.isContentEditable)
      ) {
        return;
      }

      if (event.key === 'ArrowDown' || event.keyCode === 40) {
        if (currentIndex < list.length - 1) {
          const newIndex = currentIndex + 1;
          const newItem = list[newIndex];
          if (newItem) {
            const itemId = getItemId(newItem);
            if (itemId) {
              onNavigate(newIndex, itemId);
            }
          }
        }
      } else if (event.key === 'ArrowUp' || event.keyCode === 38) {
        if (currentIndex > 0) {
          const newIndex = currentIndex - 1;
          const newItem = list[newIndex];
          if (newItem) {
            const itemId = getItemId(newItem);
            if (itemId) {
              onNavigate(newIndex, itemId);
            }
          }
        }
      }
    };

    document.addEventListener('keydown', handleArrowKeyNavigation);

    return () => {
      document.removeEventListener('keydown', handleArrowKeyNavigation);
    };
  }, [list, currentIndex, getItemId, onNavigate]);

  return null;
};

export default ArrowKeyNavigationHandler;
